import React from 'react';
import './Css/Experience.css';
import siteConfig from "../config/site.config";

export const Experience = () => {

  return (
    <div className="timeline">
      {siteConfig.experiences.map((exp, index) => (
        <div className={`timeline-item ${index % 2 === 0 ? 'even' : 'odd'}`} key={index}>
          <div className="timeline-period">{exp.period}</div>
          <div className="timeline-content">
            <h3 className="role">{exp.role}</h3>
            <div className="company">
              <span className="company-name">{exp.company}</span>
              <span className="job-type">· {exp.type}</span>
            </div>
            <ul className="achievements">
              {exp.achievements.map((achievement, i) => (
                <li key={i}>{achievement}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}; 